Postlogin.Admin = Postlogin.Admin || {};
Postlogin.DBStats = (function () {
    const initGoogleChart = function () {
        const procedure = $('#procedure_chart').attr('data-procedure-name');

        // Load the Visualization API and the corechart package.
        google.charts.load('current', { packages: ['corechart'] });

        // Set a callback to run when the Google Visualization API is loaded.
        google.charts.setOnLoadCallback(drawCharts);

        // Callback that creates and populates a data table,
        // instantiates the pie chart, passes in the data and
        // draws it.
        function drawCharts() {
            const jsonData = $.ajax({
                url: `/admin/tools/database-stats/${procedure}`,
                dataType: 'json',
                method: 'POST',
                async: false,
            }).responseText;

            // Create our data table out of JSON data loaded from server.
            const data = new google.visualization.DataTable(jsonData);

            // Instantiate and draw our chart, passing in some options.
            const chart = new google.visualization.LineChart(document.getElementById('procedure_chart'));

            const options = {
                title: `Calls of \`${procedure}\``,
            };

            chart.draw(data, options);
        }
    };

    const init = function () {
        initGoogleChart();
    };

    return {
        init,
    };
}());
